/* IZU Paros: submenus for the left-hand menu drawer and the desktop header links. Plain JavaScript. */
(() => {
  const menu = document.getElementById("menu");
  const hoverable = window.matchMedia("(hover: hover) and (pointer: fine)");

  // ---------- Drawer: a secondary panel opens beside the drawer for items that have sub-options ----------
  if (menu) {
    const items = Array.from(menu.querySelectorAll("[data-menu-item]"));
    let leaveTimer = null;
    const setOpen = (item, open) => {
      const btn = item.querySelector(".menu__parent"); if (!btn) return;
      if (!open) delete item.dataset.pinned;
      item.classList.toggle("is-open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) item.querySelector(".menu__sub").style.setProperty("--sub-top", item.offsetTop + "px");
    };
    const closeAll = except => items.forEach(i => { if (i !== except) setOpen(i, false); });
    items.forEach(item => {
      const btn = item.querySelector(".menu__parent");
      if (btn) btn.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");
        if (hoverable.matches && isOpen && !item.dataset.pinned) { item.dataset.pinned = "1"; return; }   // opened by hover: a click keeps it open
        closeAll(item); setOpen(item, !isOpen); delete item.dataset.pinned;
      });
      item.addEventListener("mouseenter", () => {
        if (!hoverable.matches) return;
        clearTimeout(leaveTimer);
        if (btn) { closeAll(item); setOpen(item, true); } else closeAll(null);   // items without sub-options never open a panel
      });
      item.addEventListener("focusin", e => { if (!btn && !item.contains(e.target.closest(".menu__sub"))) closeAll(null); });
    });
    menu.addEventListener("mouseleave", () => { if (hoverable.matches) leaveTimer = setTimeout(() => closeAll(null), 180); });
    menu.addEventListener("mouseenter", () => clearTimeout(leaveTimer));
    document.addEventListener("izu:menu-closed", () => closeAll(null));
    document.addEventListener("keydown", e => {
      if (e.key !== "Escape") return;
      const open = items.find(i => i.classList.contains("is-open"));
      if (open) { const b = open.querySelector(".menu__parent"); closeAll(null); if (b) b.focus(); e.stopImmediatePropagation(); }   // first Escape closes the panel, the next closes the drawer
    }, true);
  }

  // ---------- Desktop header links: small dropdown under items that have sub-options ----------
  const navItems = Array.from(document.querySelectorAll("[data-navitem]"));
  if (navItems.length) {
    let timer = null;
    const setNav = (item, open) => { if (!open) delete item.dataset.pinned; item.classList.toggle("is-open", open); const b = item.querySelector(".navitem__btn"); if (b) b.setAttribute("aria-expanded", open ? "true" : "false"); };
    const closeNav = except => navItems.forEach(i => { if (i !== except) setNav(i, false); });
    navItems.forEach(item => {
      const btn = item.querySelector(".navitem__btn");
      btn.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");
        if (hoverable.matches && isOpen && !item.dataset.pinned) { item.dataset.pinned = "1"; return; }
        closeNav(item); setNav(item, !isOpen); delete item.dataset.pinned;
      });
      item.addEventListener("mouseenter", () => { if (!hoverable.matches) return; clearTimeout(timer); closeNav(item); setNav(item, true); });
      item.addEventListener("mouseleave", () => { if (hoverable.matches) timer = setTimeout(() => setNav(item, false), 160); });
      item.addEventListener("focusout", e => { if (!item.contains(e.relatedTarget)) setNav(item, false); });
    });
    // hovering or focusing a link without sub-options closes any open dropdown
    document.querySelectorAll(".nav__links > a").forEach(a => { a.addEventListener("mouseenter", () => closeNav(null)); a.addEventListener("focus", () => closeNav(null)); });
    document.addEventListener("click", e => { if (!e.target.closest("[data-navitem]")) closeNav(null); });
    document.addEventListener("keydown", e => {
      if (e.key !== "Escape") return;
      const open = navItems.find(i => i.classList.contains("is-open"));
      if (open) { closeNav(null); open.querySelector(".navitem__btn").focus(); }
    });
  }
})();
